import CityPage from "../CityPage";

export default function Naperville() {
  return <CityPage slug="naperville" />;
}
